import React from 'react';

export const Footer = () => {
  return (
    <div className="h-16 bg-gray-200 border-t border-gray-300 grid items-center justify-center">
      <p className="text-gray-500"> © 2020 by CRT. All right reserved.</p>
    </div>
  );
};
